import React, { Fragment, useState } from 'react';
import { Container, Page, Grid, Card, Button, Dimmer } from "tabler-react";
import StoriesCard from './storiesCard'
import { useFetch } from '../../../lib/useFetch';
import SearchInput from '../../../components/searchInput';

const Stories = ({ openMainModal }) => {
  const [reload, toggleReload] = useState(false)
  const [searchQuery, setSearchQuery] = useState('');

  const searchParam = searchQuery ? `?search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading } = useFetch(`stories${searchParam}`, reload);

  return (
    <Fragment>
      <Container>
        <Page.Header>
          <Page.Title>Stories</Page.Title>
        </Page.Header>
        <Card>
          <Dimmer active={loading} loader={loading}><Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={setSearchQuery} />
              <Button
                className="ml-2"
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('story-create', null, () => toggleReload(r => !r))}
              >
                Create Story
                </Button>
            </Card.Options>
          </Card.Header>
            {!loading && data && data.length < 0 &&
              <div className="alert alert-primary m-0">
                No Stories to show!
              </div>
            }
            {!loading && data && data.length > 0 &&
              <Card.Body>
                <Grid>
                  <Grid.Row>
                    {data.map((story, i) => (
                      <Grid.Col  xs={12} sm={6} md={4} lg={3} key={story['_id']}>
                        <StoriesCard story={story} openMainModal={openMainModal}
                          reload={() => toggleReload(r => !r)} />
                      </Grid.Col>
                    ))}
                  </Grid.Row>
                </Grid>
              </Card.Body>
            }
          </Dimmer>
        </Card>
      </Container>
    </Fragment>
  );
}

export default Stories;
